import React, { useState } from 'react';
import Dashboard from './components/Dashboard';
import Login from './components/Login';

function App() {
  const [authenticated, setAuthenticated] = useState(() => Boolean(localStorage.getItem('rf_token')));

  const handleLoginSuccess = () => {
    setAuthenticated(true);
  };

  const handleLogout = () => {
    setAuthenticated(false);
  };

  return authenticated ? <Dashboard onLogout={handleLogout} /> : <Login onLogin={handleLoginSuccess} />;
}

export default App;
